"use client";


export default function SectionAnchorId(props: any) {
  const {anchorId} = props;

  const isInFrame = (typeof window !== "undefined") && window.self !== window.top;

  return (
          <div id={anchorId}>
            {isInFrame ? `Section #ID: ${anchorId}` : ''}
          </div>
  );
}